import React, { createContext, useState, useContext } from "react";

const BreadcrumbContext = createContext();

export const BreadcrumbProvider = ({ children }) => {
    const [customName, setCustomName] = useState(null);
    return (
        <BreadcrumbContext.Provider value={{ customName, setCustomName }}>
            {children}
        </BreadcrumbContext.Provider>
    );
};

export const useBreadcrumb = () => useContext(BreadcrumbContext);
